import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import * as sensitiveData from 'constants/sensitiveDataTypes';
import ProtectedData from 'components/common/ProtectedData/ProtectedData';
import { getSelectedOrderFromOrdersSearch } from '../../../extractFromState';
import { formatOrderDateToLocalTime } from '../../../util/index';
import {
  OrderDetailsPage,
  TableTd,
  OrderTable,
  Title,
  TitleImage,
  TitleRow,
  TableTr,
  TableTBody,
} from '../OrderDetails.styles';

const NA = 'Not Available';

const centsParser = (cents) => {
  cents = parseInt(cents);

  return typeof cents == 'number' && !isNaN(cents) ? `$${cents}` : null;
};

const protectData = (order, path, type) => {
  const value = get(order, path);

  return value ? (
    <ProtectedData
      data={value}
      dataType={type}
      component={'SalesforceOrderDetailsComponent'}
      customerId={order.user.Id}
    />
  ) : (
    NA
  );
};

const address = (order) => {
  const addressArray = [
    get(order, 'street'),
    get(order, 'city'),
    get(order, 'state'),
    get(order, 'postalCode'),
    get(order, 'country'),
  ].filter((value) => value);

  if (addressArray && addressArray.length) {
    return addressArray.map((item) => <div key={item}>{item}</div>);
  }

  return null;
};

const renderOrderItems = (orderItems) => {
  if (!orderItems.length) {
    return (
      <TableTr>
        <TableTd>Line Items</TableTd>
        <TableTd>{NA}</TableTd>
      </TableTr>
    );
  }

  return orderItems.map((orderItem, index) => (
    <TableTr key={orderItem.OrderItemNumber}>
      <TableTd>{index === 0 ? 'Items' : ''}</TableTd>
      <TableTd>
        {orderItem.Quantity} "{orderItem.name}": {centsParser(orderItem.TotalPrice)} : {orderItem.Status}
      </TableTd>
    </TableTr>
  ));
};

const SalesforceOrderDetailsComponent = (props) => {
  const { selectedOrder } = props;

  return (
    <OrderDetailsPage>
      <TitleRow>
        <Title>Order Summary</Title>
        <span>
          <TitleImage alt="" src="/images/green-clipboard.svg" />
        </span>
      </TitleRow>
      <hr />
      <OrderTable>
        <TableTBody>
          <TableTr>
            <TableTd>Order ID</TableTd>
            <TableTd>{selectedOrder.Id || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Order Number</TableTd>
            <TableTd>{selectedOrder.OrderNumber || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Order Status</TableTd>
            <TableTd>{selectedOrder.Status || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Order Type</TableTd>
            <TableTd>{selectedOrder.Type || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Account Name</TableTd>
            <TableTd>{get(selectedOrder, 'account.Name', NA)}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Contract Number</TableTd>
            <TableTd>{get(selectedOrder, 'contract.ContractNumber', NA)}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Created At</TableTd>
            <TableTd>{formatOrderDateToLocalTime(selectedOrder.CreatedDate, 'salesforce')}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Est. Shipping Date</TableTd>
            <TableTd>{selectedOrder.EstimatedShippingDate || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Owner Name</TableTd>
            <TableTd>{protectData(selectedOrder, 'user.Name', sensitiveData.fullName)}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Owner Email</TableTd>
            <TableTd>{protectData(selectedOrder, 'user.Email', sensitiveData.email)}</TableTd>
          </TableTr>
          {renderOrderItems(selectedOrder.orderItems)}
          <TableTr>
            <TableTd>Total Amount</TableTd>
            <TableTd>{centsParser(selectedOrder.TotalAmount) || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Shipping Address</TableTd>
            <TableTd>{address(selectedOrder.ShippingAddress) || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Billing Address</TableTd>
            <TableTd>{address(selectedOrder.BillingAddress) || NA}</TableTd>
          </TableTr>
        </TableTBody>
      </OrderTable>
    </OrderDetailsPage>
  );
};

SalesforceOrderDetailsComponent.propTypes = {
  selectedOrder: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  selectedOrder: getSelectedOrderFromOrdersSearch(state),
});

export default connect(mapStateToProps)(SalesforceOrderDetailsComponent);
